module.exports = __webpack_public_path__ + "static/media/send_black_24dp.457ea286.svg";